import { useEffect, useState, useMemo, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../../API';

export const useSubQr = () => {
    const [state, setState] = useState({ parent: null, setup: null, subQr: null });
    const [isLoading,setIsLoading] = useState(true);

    const params = useParams();
    const { qrId, subQrId } = useMemo(() => ({ qrId: params.id, subQrId: params.subId }), [params.id, params.subId]);

    const navigate = useNavigate();

    const initializeSubQr = useCallback(async (response, setSuccess) => {
        try {
            await API.initializeSubQr({ qrId, subQrId, response });
            setSuccess(true);
        } catch (err) {
            console.error('Error initializing subQr: ', err);
        };
    },[]);

    useEffect(() => {
        if (!qrId || !subQrId) {
            navigate('/notfound');
        };
    },[qrId, subQrId]);

    useEffect(() => {
        let mounted = true;
        const handleGetSubQrData = async () => {
            try {
                setIsLoading(true);
                const { data } = await API.getSubQrData({ qrId, subQrId });

                if (data?.hasOwnProperty('parent') && data?.hasOwnProperty('setup') && data?.hasOwnProperty('subQr') && mounted) {
                    setState(data);
                    setIsLoading(false);
                };
            } catch (err) {
                console.error('Could not retrieve sub qr init docs: ', err);
                navigate('/notfound');
            };
        };

        if (qrId && subQrId && !state.parent && !state.setup && !state.subQr && mounted) {
            handleGetSubQrData();
        };

        return () => {
            mounted = false;
        };
    },[state.parent, state.setup, state.subQr]);

    return useMemo(() => ({ data: state, initializeSubQr, isLoading }), [state.parent, state.setup, state.subQr]);
};
